export const bankAccountConstants = {
  MONNIEPOINT_BANK_CODE: "50515",
};
